module.exports = __webpack_public_path__ + "2a47d0b3b13d380001c8aeb60375c31e.jpg";